import ApiService from "../api.services";

const RouteService = {
  list: async function () {
    try {
      const response = await ApiService.get("/api/routes");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  realtime: async function (date) {
    try {
      const response = await ApiService.get(
        `/api/routes/pendencies/day?date=${date}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/routes/pendency/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRouteDetails: async function (id) {
    try {
      const response = await ApiService.get(`/api/routes/find/details/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async function (data) {
    try {
      const res = await ApiService.post("/api/routes", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  update: async function (id, form) {
    const data = {
      route: form,
    };
    try {
      const response = await ApiService.put(`/api/routes/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  transfer: async function (data) {
    try {
      const response = await ApiService.post(
        `/api/routes/pendencies/transfer`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addCustomer: async function (data) {
    try {
      const response = await ApiService.post(
        `/api/routes/pendencies/customer`,
        data
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  removeCustomer: async function (id) {
    try {
      const response = await ApiService.delete(
        `/api/routes/pendencies/customer/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  customer: async function () {
    try {
      const response = await ApiService.get(
        `/api/routes/pendencies/customer`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/routes/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findByCustomer: async function (customer_id) {
    try {
      const response = await ApiService.get(
        `/api/routes/pendency/customer/${customer_id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default RouteService;

export { RouteService };
